import { createContext } from "react";

const CourseContext = createContext();

export default CourseContext;